import React, { useEffect, Suspense } from 'react';
import { lazy } from './lib/lazyRetry';
import ErrorBoundary from './components/ErrorBoundary';
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from './components/ui/sonner';
import InstallAppPrompt from './components/InstallAppPrompt';
import PublicLayout from './components/PublicLayout';
import Landing from './pages/lp/Landing'; // eager: é a página que recebe o tráfego pago (evita uma ida ao servidor)
const HomePage = lazy(() => import('./pages/HomePage'));
const Hospedagens = lazy(() => import('./pages/Hospedagens'));
const CustomPackage = lazy(() => import('./pages/CustomPackage'));
const CarRental = lazy(() => import('./pages/CarRental'));
const PropertyDetail = lazy(() => import('./pages/PropertyDetail'));
const MemberLayout = lazy(() => import('./pages/member/MemberLayout'));
const MemberLogin = lazy(() => import('./pages/member/MemberLogin'));
const MemberReservations = lazy(() => import('./pages/member/Reservations'));
const Profile = lazy(() => import('./pages/member/Profile'));
const Dependents = lazy(() => import('./pages/member/Dependents'));
const IndicacoesMembro = lazy(() => import('./pages/member/Indicacoes'));
const IndicacoesAdmin = lazy(() => import('./pages/admin/Indicacoes'));
const Password = lazy(() => import('./pages/member/Password'));
const CreditPage = lazy(() => import('./pages/CreditPage'));
const Cobrancas = lazy(() => import('./pages/member/Cobrancas'));
const PaymentPage = lazy(() => import('./pages/PaymentPage'));
const CheckoutPacote = lazy(() => import('./pages/CheckoutPacote'));
const Credenciamento = lazy(() => import('./pages/Credenciamento'));
const ReservePage = lazy(() => import('./pages/ReservePage'));
const RequestReservationPage = lazy(() => import('./pages/RequestReservationPage'));
const MeusPacotes = lazy(() => import('./pages/member/MeusPacotes'));
const MeuPacoteDetalhe = lazy(() => import('./pages/member/MeuPacoteDetalhe'));
const MemberHome = lazy(() => import('./pages/member/MemberHome'));
const AluguelCarrosMembro = lazy(() => import('./pages/member/AluguelCarros'));
const PaymentCarRentalPage = lazy(() => import('./pages/PaymentCarRentalPage'));
const AdminAluguelCarros = lazy(() => import('./pages/admin/AluguelCarros'));
const Receitas = lazy(() => import('./pages/admin/financeiro/Receitas'));
const GestaoVendas = lazy(() => import('./pages/admin/financeiro/GestaoVendas'));
const AdminLayout = lazy(() => import('./pages/admin/AdminLayout'));
const Dashboard = lazy(() => import('./pages/admin/Dashboard'));
const SellerLayout = lazy(() => import('./pages/seller/SellerLayout'));
const SellerDashboard = lazy(() => import('./pages/seller/Dashboard'));
const MeusTitulos = lazy(() => import('./pages/seller/MeusTitulos'));
const SellerMateriais = lazy(() => import('./pages/seller/Materiais'));
const CoordenadorDashboard = lazy(() => import('./pages/seller/CoordenadorDashboard'));
const Associados = lazy(() => import('./pages/seller/Associados'));
const AssociadoPage = lazy(() => import('./pages/seller/AssociadoPage'));
const NovoAssociadoPage = lazy(() => import('./pages/seller/NovoAssociadoPage'));
const LancarJoiaPage = lazy(() => import('./pages/seller/LancarJoiaPage'));
const Activations = lazy(() => import('./pages/admin/Activations'));
const ActivationAuditPage = lazy(() => import('./pages/admin/ActivationAuditPage'));
const Users = lazy(() => import('./pages/admin/Users'));
const UsuariosAdmin = lazy(() => import('./pages/admin/UsuariosAdmin'));
const TodosUsuarios = lazy(() => import('./pages/admin/TodosUsuarios'));
const Vendedores = lazy(() => import('./pages/admin/Vendedores'));
const VendedorFichaPage = lazy(() => import('./pages/admin/VendedorFichaPage'));
const Materiais = lazy(() => import('./pages/admin/Materiais'));
const RelatorioTitulos = lazy(() => import('./pages/admin/RelatorioTitulos'));
const Custos = lazy(() => import('./pages/admin/financeiro/Custos'));
const Contratos = lazy(() => import('./pages/admin/financeiro/Contratos'));
const ContratoFichaPage = lazy(() => import('./pages/admin/financeiro/ContratoFichaPage'));
const Creditos = lazy(() => import('./pages/admin/financeiro/Creditos'));
const Joias = lazy(() => import('./pages/admin/financeiro/Joias'));
const JoiaDetailPage = lazy(() => import('./pages/admin/financeiro/JoiaDetailPage'));
const Anuidades = lazy(() => import('./pages/admin/financeiro/Anuidades'));
const AnuidadeDetailPage = lazy(() => import('./pages/admin/financeiro/AnuidadeDetailPage'));
const Comissoes = lazy(() => import('./pages/admin/Comissoes'));
const Properties = lazy(() => import('./pages/admin/Properties'));
const PropertyForm = lazy(() => import('./pages/admin/PropertyForm'));
const Fornecedores = lazy(() => import('./pages/admin/Fornecedores'));
const Reservations = lazy(() => import('./pages/admin/Reservations'));
const ReservationDetailPage = lazy(() => import('./pages/admin/ReservationDetailPage'));
const NovaReservaAdmin = lazy(() => import('./pages/admin/NovaReservaAdmin'));
const PacotesPersonalizados = lazy(() => import('./pages/admin/PacotesPersonalizados'));
const PacoteAdminPage = lazy(() => import('./pages/admin/PacoteAdminPage'));
const Personalizar = lazy(() => import('./pages/admin/Personalizar'));
const Site = lazy(() => import('./pages/admin/Site'));
const SMTPPage = lazy(() => import('./pages/admin/configuracoes/SMTP'));
const AsaasPage = lazy(() => import('./pages/admin/configuracoes/Asaas'));
const PricingPage = lazy(() => import('./pages/admin/configuracoes/Pricing'));
const Mensagens = lazy(() => import('./pages/admin/Mensagens'));
const ConsultoresExpansao = lazy(() => import('./pages/admin/ConsultoresExpansao'));
const MeuBonus = lazy(() => import('./pages/seller/MeuBonus'));
const Carteira = lazy(() => import('./pages/seller/Carteira'));
const Equipe = lazy(() => import('./pages/seller/Equipe'));
const WhatsAppPage = lazy(() => import('./pages/admin/configuracoes/WhatsApp'));
const CortesiaAdminPage = lazy(() => import('./pages/admin/configuracoes/CortesiaAdmin'));
const CortesiasValidadas = lazy(() => import('./pages/admin/CortesiasValidadas'));
const Coordenacao = lazy(() => import('./pages/admin/Coordenacao'));
const Cortesia = lazy(() => import('./pages/Cortesia'));
const Confirmacao = lazy(() => import('./pages/lp/Confirmacao'));
const Privacidade = lazy(() => import('./pages/lp/Privacidade'));
const Leads = lazy(() => import('./pages/admin/Leads'));
const Atendimento = lazy(() => import('./pages/admin/Atendimento'));
const LeadsConfig = lazy(() => import('./pages/admin/configuracoes/LeadsLP'));
const FollowupConfig = lazy(() => import('./pages/admin/configuracoes/Followup'));
const MeusLeads = lazy(() => import('./pages/seller/MeusLeads'));
const MeusAtendimentos = lazy(() => import('./pages/seller/MeusAtendimentos'));
const CheckoutAdesaoPage = lazy(() => import('./pages/seller/CheckoutAdesaoPage'));
const AssinarContrato = lazy(() => import('./pages/AssinarContrato'));
const CadastroCliente = lazy(() => import('./pages/CadastroCliente'));
const Adesao = lazy(() => import('./pages/Adesao'));
const AdesaoDigitalAdminPage = lazy(() => import('./pages/admin/configuracoes/AdesaoDigitalAdmin'));
import { SettingsProvider } from './SettingsContext';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

// Uma falha ao desenhar uma tela mostra aviso (e recarrega se for versão antiga) em vez de tela branca; troca de rota limpa o erro.
function RouteBoundary({ children }) {
  const { pathname } = useLocation();
  return <ErrorBoundary key={pathname}>{children}</ErrorBoundary>;
}

function App() {
  return (
    <div className="App">
      <SettingsProvider>
        <BrowserRouter>
        <ScrollToTop />
        <PublicLayout>
          <RouteBoundary>
          <Suspense fallback={<div className="min-h-[60vh]" aria-busy="true" />}>
          <Routes>
            {/* Rotas Públicas */}
            <Route path="/" element={<HomePage />} />
            <Route path="/cortesia" element={<Landing />} />
            <Route path="/cortesia/confirmacao" element={<Confirmacao />} />
            <Route path="/cortesia/voucher" element={<Cortesia />} />
            <Route path="/privacidade" element={<Privacidade />} />
            <Route path="/assinar/:token" element={<AssinarContrato />} />
            <Route path="/cadastro/:token" element={<CadastroCliente />} />
            <Route path="/associe-se" element={<Adesao />} />
            <Route path="/hospedagens" element={<Hospedagens />} />
            <Route path="/casas-praia" element={<Navigate to="/hospedagens?types=beach_house" replace />} />
            <Route path="/resorts" element={<Navigate to="/hospedagens?types=resort" replace />} />
            <Route path="/monte-pacote" element={<CustomPackage />} />
            <Route path="/aluguel-carros" element={<CarRental />} />
            <Route path="/imovel/:id" element={<PropertyDetail />} />
            <Route path="/reservar/:propertyId" element={<ReservePage />} />
            <Route path="/solicitar-reserva" element={<RequestReservationPage />} />
            <Route path="/login" element={<MemberLogin />} />
            <Route path="/area-associado" element={<MemberLayout />}>
              <Route index element={<MemberHome />} />
              <Route path="reservas" element={<MemberReservations />} />
              <Route path="dados" element={<Profile />} />
              <Route path="dependentes" element={<Dependents />} />
              <Route path="indicacoes" element={<IndicacoesMembro />} />
              <Route path="senha" element={<Password />} />
              <Route path="meus-pacotes" element={<MeusPacotes />} />
              <Route path="meus-pacotes/:id" element={<MeuPacoteDetalhe />} />
              <Route path="aluguel-carros" element={<AluguelCarrosMembro />} />
              <Route path="creditos" element={<CreditPage />} />
              <Route path="cobrancas" element={<Cobrancas />} />
            </Route>
            <Route path="/meu-credito" element={<Navigate to="/area-associado/creditos" replace />} />
            <Route path="/pagamento/:id" element={<PaymentPage />} />
            <Route path="/checkout/pacote/:id" element={<CheckoutPacote />} />
            <Route path="/credenciamento/:token" element={<Credenciamento />} />
            <Route path="/pagamento/carro/:id" element={<PaymentCarRentalPage />} />

            {/* Rotas do Vendedor (layout isolado) */}
            <Route path="/vendedor" element={<SellerLayout />}>
              <Route index element={<SellerDashboard />} />
              <Route path="dashboard" element={<SellerDashboard />} />
              <Route path="coordenacao" element={<CoordenadorDashboard />} />
              <Route path="associados" element={<Associados />} />
              <Route path="associados/novo" element={<NovoAssociadoPage />} />
              <Route path="associados/:associadoId" element={<AssociadoPage />} />
              <Route path="associados/:contractId/checkout" element={<CheckoutAdesaoPage />} />
              <Route path="titulos" element={<MeusTitulos />} />
              <Route path="materiais" element={<SellerMateriais />} />
              <Route path="bonus" element={<MeuBonus />} />
              <Route path="carteira" element={<Carteira />} />
              <Route path="equipe" element={<Equipe />} />
              <Route path="leads" element={<MeusLeads />} />
              <Route path="atendimentos" element={<MeusAtendimentos />} />
            </Route>

            {/* Rotas Administrativas (layout isolado) */}
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="ativacoes" element={<Activations />} />
              <Route path="ativacoes/:requestId" element={<ActivationAuditPage />} />
              <Route path="ativacoes/:requestId/editar" element={<NovoAssociadoPage adminMode editMode />} />
              <Route path="usuarios" element={<Contratos />} />
              <Route path="usuarios/novo" element={<NovoAssociadoPage adminMode />} />
              <Route path="usuarios/legacy" element={<Users />} />
              <Route path="todos-usuarios" element={<TodosUsuarios />} />
              <Route path="vendedores" element={<Vendedores />} />
              <Route path="vendedores/materiais" element={<Materiais />} />
              <Route path="vendedores/relatorio-titulos" element={<RelatorioTitulos />} />
              <Route path="vendedores/:sellerId" element={<VendedorFichaPage />} />
              <Route path="pacotes-personalizados" element={<PacotesPersonalizados />} />
              <Route path="pacotes-personalizados/:id" element={<PacoteAdminPage />} />
              <Route path="creditos" element={<Navigate to="/admin/usuarios" replace />} />
              <Route path="financeiro/contratos" element={<Navigate to="/admin/usuarios" replace />} />
              <Route path="financeiro/contratos/novo" element={<Navigate to="/admin/usuarios/novo" replace />} />
              <Route path="financeiro/contratos/:contractId" element={<ContratoFichaPage />} />
              <Route path="financeiro/contratos/:contractId/lancar-joia" element={<LancarJoiaPage adminMode />} />
              <Route path="financeiro/joias" element={<Joias />} />
              <Route path="financeiro/joias/:contractId" element={<JoiaDetailPage />} />
              <Route path="financeiro/anuidades" element={<Anuidades />} />
              <Route path="financeiro/anuidades/:contractId" element={<AnuidadeDetailPage />} />
              <Route path="financeiro/receitas" element={<Receitas />} />
              <Route path="financeiro/gestao-vendas" element={<GestaoVendas />} />
              <Route path="financeiro/creditos" element={<Creditos />} />
              <Route path="financeiro/custos" element={<Custos />} />
              <Route path="financeiro/comissoes" element={<Comissoes />} />
              <Route path="propriedades" element={<Properties />} />
              <Route path="propriedades/nova" element={<PropertyForm />} />
              <Route path="propriedades/:id/editar" element={<PropertyForm />} />
              <Route path="fornecedores" element={<Fornecedores />} />
              <Route path="reservas" element={<Reservations />} />
              <Route path="reservas/nova" element={<NovaReservaAdmin />} />
              <Route path="reservas/:id" element={<ReservationDetailPage />} />
              <Route path="aluguel-carros" element={<AdminAluguelCarros />} />
              <Route path="configuracoes/personalizar" element={<Personalizar />} />
              <Route path="configuracoes/site" element={<Site />} />
              <Route path="configuracoes/precos" element={<PricingPage />} />
              <Route path="configuracoes/smtp" element={<SMTPPage />} />
              <Route path="configuracoes/asaas" element={<AsaasPage />} />
              <Route path="configuracoes/whatsapp" element={<WhatsAppPage />} />
              <Route path="configuracoes/cortesia" element={<CortesiaAdminPage />} />
              <Route path="configuracoes/adesao-digital" element={<AdesaoDigitalAdminPage />} />
              <Route path="cortesias-validadas" element={<CortesiasValidadas />} />
              <Route path="coordenacao" element={<Coordenacao />} />
              <Route path="consultores-expansao" element={<ConsultoresExpansao />} />
              <Route path="usuarios-admin" element={<UsuariosAdmin />} />
              <Route path="mensagens" element={<Mensagens />} />
              <Route path="leads" element={<Leads />} />
              <Route path="atendimento" element={<Atendimento />} />
              <Route path="indicacoes" element={<IndicacoesAdmin />} />
              <Route path="configuracoes/leads" element={<LeadsConfig />} />
              <Route path="configuracoes/followup" element={<FollowupConfig />} />
            </Route>
          </Routes>
          </Suspense>
          </RouteBoundary>
        </PublicLayout>
        <InstallAppPrompt />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
      </SettingsProvider>
    </div>
  );
}

export default App;
